<template>
  <div class="reactions">
    <ul
      v-if="item.reactions &&
            (item.reactions.like ||
            item.reactions.dislike ||
            item.reactions.haha ||
            item.reactions.wow ||
            item.reactions.sad ||
            item.reactions.angry ||
            item.reactions.pressf)"
      class="stats"
    >
      <li v-if="item.reactions.like && item.reactions.like.length">
        <i class="like" /> {{ item.reactions.like.length }}
      </li>
      <li v-if="item.reactions.dislike && item.reactions.dislike.length">
        <i class="dislike" /> {{ item.reactions.dislike.length }}
      </li>
      <li v-if="item.reactions.haha && item.reactions.haha.length">
        <i class="haha" /> {{ item.reactions.haha.length }}
      </li>
      <li v-if="item.reactions.wow && item.reactions.wow.length">
        <i class="wow" /> {{ item.reactions.wow.length }}
      </li>
      <li v-if="item.reactions.sad && item.reactions.sad.length">
        <i class="sad" /> {{ item.reactions.sad.length }}
      </li>
      <li v-if="item.reactions.angry && item.reactions.angry.length">
        <i class="angry" /> {{ item.reactions.angry.length }}
      </li>
      <li v-if="item.reactions.pressf && item.reactions.pressf.length">
        <i class="pressf" /> {{ item.reactions.pressf.length }}
      </li>
    </ul>
    <transition name="fadeInFast" mode="out-in">
      <div v-if="showReactions" @click="showReactions = false" class="list">
        <i
          v-for="(react, i) in reactions"
          :key="`reaction-${react}-${i}`"
          @click="setReaction(item.id, react)"
          :class="react"
        />
        <i @click="showReactions = false" class="close" />
      </div>
      <span
        v-else-if="(!item.owner_id || !user || user.id !== item.owner_id)"
        @click="showReactions = !showReactions"
      ><b>&#128077;</b> {{ showReactions ? 'Отмена' : 'Оценить' }}</span>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: { item: { type: Object, required: true, default: () => ({}) } },
  computed: mapState(['user']),
  data() {
    const reactions = ['like', 'dislike', 'haha', 'wow', 'sad', 'angry', 'pressf']

    return {
      reactions,
      showReactions: false,
      gets: {}
    }
  },
  methods: {
    async setReaction(id, reaction) {
      if (!this.user) {
        this.$store.commit('setError', { status: 'info', msg: 'Необходимо войти на сайт' })
        setTimeout(() => this.$store.commit('clearError'), 2000)
        return
      }

      if (this.gets.setReaction) return

      if (this.item.reactions[reaction]) {
        if (this.item.reactions[reaction].includes(this.user.id)) {
          this.$store.commit('setError', { status: 'info', msg: 'Вы уже так реагировали' })
          setTimeout(() => this.$store.commit('clearError'), 2000)
          return
        }
        this.item.reactions[reaction].push(this.user.id)
      } else {
        this.item.reactions[reaction] = [this.user.id]
      }

      this.gets.setReaction = true

      const body = { id, reaction }

      const { data } = await this.$axios.post('/api/reactions', body)

      if (data.error) {
        this.$store.commit('setError', { status: 'info', msg: data.error.message })
        setTimeout(() => this.$store.commit('clearError'), 2000)
      }

      delete this.gets.setReaction
      this.showReactions = false
    }
  }
}
</script>

<style lang="stylus">
.reactions
  display inline-block
  position relative
  margin 20px 0
  &.absolute
    position absolute
    top 20px
    right 20px
  span
    display inline-block
    margin 0 5px
    padding 7px 14px
    font-weight 400
    font-size 1.4rem
    color #000
    background-color #fff
    border-radius 5px
    // text-transform uppercase
    box-shadow 0 0 10px 0 rgba(0 0 0 0.2)
    cursor pointer
    transition all .2s ease
    &:hover
      background-color #8365bc // #6e427e
      color #fff
    b
      font-size 1.6rem
      font-weight 400
      // vertical-align text-bottom
  .list
    display inline-block
    position relative
    top -7px
    width 296px
    padding 2px 4px 2px 2px
    background-color #fff
    box-shadow 0 0 10px 0px rgba(0 0 0 0.3)
    border-radius 30px
    z-index 1
    i
      display inline-block
      width 40px
      height 40px
      cursor pointer
      margin 0 1px
      background-position center
      background-size 60px
      border-radius 50%
      vertical-align top
      transition all .2s ease
      &:hover
        transform scale(1.2)
      &.like
        background-image url('/static_files/reactions/like.gif')
      &.dislike
        background-image url('/static_files/reactions/dislike.gif')
      &.haha
        background-image url('/static_files/reactions/haha.gif')
      &.wow
        background-image url('/static_files/reactions/wow.gif')
      &.sad
        background-image url('/static_files/reactions/sad.gif')
      &.angry
        background-image url('/static_files/reactions/angry.gif')
      &.pressf
        margin-top 2px
        width 36px
        height 36px
        background-image url('/static_files/reactions/pressf.png')
        background-size 36px
      &.close
        position absolute
        top -30px
        left calc(50% - 10px)
        width 20px
        height 20px
        padding 6px
        background #fff url('/static_files/icons/cancel.svg') center no-repeat
        background-size 8px
        box-shadow 0 0 10px 0 rgba(0 0 0 0.35)
  .stats
    list-style none
    display inline-block
    position relative
    top 2px
    margin-right 5px
    padding 2px 5px
    background-color #fff
    box-shadow 0 0 10px 0px rgba(0 0 0 0.1)
    border-radius 20px
    cursor pointer
    li
      display inline-block
      font-size 1.4rem
      margin 0 2px
      i
        display inline-block
        width 16px
        height 16px
        vertical-align text-top
        animation 1s toFadeTop ease-in
        background-size 16px
        &.like
          background-image url('/static_files/reactions/like.png')
        &.dislike
          background-image url('/static_files/reactions/dislike.png')
        &.haha
          background-image url('/static_files/reactions/haha.png')
        &.wow
          background-image url('/static_files/reactions/wow.png')
        &.sad
          background-image url('/static_files/reactions/sad.png')
        &.angry
          background-image url('/static_files/reactions/angry.png')
        &.pressf
          background-image url('/static_files/reactions/pressf.png')
</style>
